"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemFactory = void 0;
const BaseRequestHandler_1 = require("../requestHandler/BaseRequestHandler");
const ItemSearchQuery_1 = require("./ItemSearchQuery");
const timer_1 = __importDefault(require("../logger/timer"));
const getRequestConfigWithToken_1 = require("../requestHandler/getRequestConfigWithToken");
class ItemFactory {
    static getItems(shopId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = new ItemSearchQuery_1.ItemSearchQuery();
            query.addItemIds(data.itemIds);
            query.setLimit(data.limit);
            query.setOffset(data.offset);
            query.setCurrencyCode(data.currencyCode);
            query.setPromotionId(data.promotionId);
            query.setCategoryId(data.categoryId);
            // As stated by Konstantin Roemer but not stated in api docu
            // customer prices are shown depending on respective get param
            query.setCustomerId(data.customerId);
            // same here
            query.setCustomerGroupId(data.customerGroupId);
            query.setOtherFields(data);
            const queryString = query.getQueryString();
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `shop/${shopId}/items?${queryString}`, configuration);
        });
    }
}
__decorate([
    timer_1.default("API", "Items")
], ItemFactory, "getItems", null);
exports.ItemFactory = ItemFactory;
